import {
  loadLocalData,
  saveLocalData,
  STORAGE_KEY_ASSESSMENT_RESULT_STATE,
} from '@northladder/utilities';

import { IDeviceAssessmentState } from './types';

type TPersistedDeviceAssessmentState = Pick<
  IDeviceAssessmentState,
  'assessments' | 'currentAssessmentStep' | 'evaluationId'
>;

/**
 * This persists the feature store  to secure local storage.
 */
export const persistFeatureAssessmentStore = (
  targetState: TPersistedDeviceAssessmentState
) => {
  saveLocalData(STORAGE_KEY_ASSESSMENT_RESULT_STATE, targetState);
};

/**
 * This retrieves and decrypts the feature store info from secure local storage.
 */
export const loadPersistedFeatureAssessmentStore = () =>
  loadLocalData<TPersistedDeviceAssessmentState>(
    STORAGE_KEY_ASSESSMENT_RESULT_STATE
  );
